import { createContext } from 'react';

export interface TreemapHoverState {
  hoveredNodeId: string | null;
  /** Ancestors, descendants, and self of the hovered node; empty when none. */
  activeNodeIds: Set<string>;
}

export const EMPTY_ACTIVE_IDS = new Set<string>();

export const TreemapHoverContext = createContext<TreemapHoverState>({
  hoveredNodeId: null,
  activeNodeIds: EMPTY_ACTIVE_IDS,
});
